import React from 'react'
import Comingsoonpage from '../../../common/Comingsoon'

const ReservationsBids = () => {
  return (
    <Comingsoonpage />
  )
}

export default ReservationsBids;